// Captcha local (sem serviço externo). O desafio é gerado no navegador e o
// token resultante é enviado no payload (meta) do login/cadastro para que o
// backend possa registrar/validar a resolução.

// Alfabeto sem caracteres ambíguos (0/O, 1/I/L).
const ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
const CHALLENGE_LENGTH = 5;

export const CAPTCHA_TTL_MS = 5 * 60 * 1000;
export const CAPTCHA_VERSION = 1;

function randomValues(length) {
  const buffer = new Uint32Array(length);
  window.crypto.getRandomValues(buffer);
  return buffer;
}

function randomText(length) {
  return Array.from(randomValues(length))
    .map((value) => ALPHABET[value % ALPHABET.length])
    .join("");
}

function randomId() {
  return Array.from(randomValues(4))
    .map((value) => value.toString(16).padStart(8, "0"))
    .join("");
}

export function createChallenge() {
  return {
    id: randomId(),
    text: randomText(CHALLENGE_LENGTH),
    issuedAt: Date.now(),
  };
}

export function isExpired(challenge) {
  return !challenge || Date.now() - challenge.issuedAt > CAPTCHA_TTL_MS;
}

function normalize(value) {
  return String(value || "")
    .replace(/\s/g, "")
    .toUpperCase();
}

export function matches(challenge, answer) {
  if (!challenge || isExpired(challenge)) return false;
  return normalize(answer) === normalize(challenge.text);
}

export function buildToken(challenge, answer) {
  const token = {
    v: CAPTCHA_VERSION,
    provider: "local",
    id: challenge.id,
    challenge: challenge.text,
    answer: normalize(answer),
    issuedAt: challenge.issuedAt,
    solvedAt: Date.now(),
  };

  return btoa(JSON.stringify(token));
}
